/* global axios */
import ApiClient from './ApiClient';

class CustomViewsAPI extends ApiClient {
  constructor() {
    super('custom_filters', { accountScoped: true });
  }

  getCustomViewsByFilterType(type) {
    return axios.get(`${this.url}?filter_type=${type}`);
  }

  deleteCustomViews(id, type) {
    return axios.delete(`${this.url}/${id}?filter_type=${type}`);
  }

  reorder({ filterType, ids }) {
    return axios.patch(`${this.url}/reorder`, {
      filter_type: filterType,
      ids,
    });
  }
}

export default new CustomViewsAPI();
